import {
    SET_CURRENT_PAGE,
    SET_FILTER_COUNTRY, 
    SET_FILTERED_TOTAL_COUNT
} from "../actions"

const initialState = {
    filterCountry: "",
    currentPage: 1,
    filteredTotalCount: 0
}

//Reducers
export default function aspStateReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_PAGE:
            console.log("setting current page", action.payload)
            return {
                ...state,
                currentPage: action.payload
            }
        case SET_FILTER_COUNTRY:
            console.log("setting filter country", action.payload)
            return {
                ...state,
                filterCountry: action.payload
            }
        case SET_FILTERED_TOTAL_COUNT:
            console.log("setting filtered total count", action.payload)
            return {
                ...state,
                filteredTotalCount: action.payload
            }
        default:
            return state
    }
}